import {CommonLink} from '../../../../../shared/components/CommonLink';

export const LinksToAdminGsskt: React.FC<{
  recruitmentItemID: number;
}> = ({recruitmentItemID}) => {
  const EDIT_ARCHIVE_LINK =
    'https://admin.gaishishukatsu.com/gs_recruiting_items/edit/';
  const CONFIRM_ARCHIVE_LINK =
    'https://admin.gaishishukatsu.com/gs_recruiting_items/screenshots/';

  return (
    recruitmentItemID && (
      <div className="mb-16">
        <p>
          ・
          <CommonLink
            href={`${EDIT_ARCHIVE_LINK}${recruitmentItemID}`}
            className="text-base text-link pc:hover:opacity-80"
          >
            この募集情報を編集する
          </CommonLink>
        </p>
        <p>
          ・
          <CommonLink
            href={`${CONFIRM_ARCHIVE_LINK}${recruitmentItemID}`}
            className="text-base text-link pc:hover:opacity-80"
          >
            この募集情報を確認する
          </CommonLink>
        </p>
      </div>
    )
  );
};
